import React from 'react';
import { useDispatch } from 'react-redux';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import Title from './Title';
import CopyLink from './CopyLink';
import CopyApiLink from './CopyApiLink';
import { Wrapper, CloseIconWrapper, CloseIcon } from './styled';
import { closeDetail } from 'Screens/Contextualization/Workspaces/actions/Actions';

const Header = () => {
  const dispatch = useDispatch();
  const handleClose = () => dispatch(closeDetail());

  useModalShortcuts({ id: 'workspace-detail', onCancel: handleClose, cancelLabel: 'Close' });

  return (
    <Wrapper>
      <Title />
      <CopyLink />
      <CopyApiLink />
      <CloseIconWrapper onClick={ handleClose }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
